import "./feedback.component.scss";
import {formatPhoneInput} from "../../../utils/format-phone-input.js";
import {MenuComponent} from "../menu/menu.component.js";
import {buildFormData} from "../../../utils/build-form-data.js";

/* для того чтобы по клику на кнопку открылась форма feedback, нужно присвоить этой кнопке атрибут [data-feedback-btn] */
export class FeedbackComponent {

    // аьрибуты для управления
    static #attr = {
        dataFeedbackInviteOpen: "[data-feedback-invite-open]", // от этого атрибута у кнопки зависит какая форма откроется
        dataFeedbackServiceOpen: "[data-feedback-service-open]", // от этого атрибута у кнопки зависит какая форма откроется
        dataFeedbackClose: "[data-feedback-close]",
        dataFeedbackTitle: "[data-feedback-title]",
    }

    static #type = {
        invite: "Заявка на встречу",
        services: "Заявка на услуги",
    }

    static #title = {
        invite: "Оставьте свои контакты для звонка",
        services: "Оставьте свои контакты, и мы расскажем вам о наших услугах",
    }

    static feedbackElement = document.getElementById("feedback");
    static feedbackTitleElement = document.querySelector(this.#attr.dataFeedbackTitle);
    static processElement = document.getElementById('feedback-process-btn');
    static userData = {};
    static fields = [
        {
            id: "name",
            name: "name",
            element: null,
            regex: /^[а-яА-ЯёЁa-zA-Z\- ]+$/,
            valid: false,
            required: true,
        },
        {
            id: "email",
            name: "email",
            element: null,
            regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            valid: false,
            required: true,
        },
        {
            id: "company-name",
            name: "company",
            element: null,
            regex: '',
            valid: true,
            required: false,
        },
        {
            id: "phone",
            name: "phone",
            element: null,
            regex: /^(\+7|8|3|\+3)\s?\(?\d{3}\)?\s?\d{3}(?:-\d{2}){2,}(?:-\d+)?$/,
            valid: true,
            required: false,
        },
    ];
    static feedbackOpen = false;

    static init() {

        this.feedbackOpen = this.feedbackElement.classList.contains("open");

        this.fields.forEach(field => {
            const inputElement = document.getElementById(field.id);
            if (!inputElement) return;

            field.element = inputElement; // Сохраняем ссылку на элемент
            const validateHandler = () => this.validateFields(field, inputElement);

            inputElement.addEventListener('input', validateHandler);
            inputElement.addEventListener('blur', validateHandler);
        });

        // Делегирование событий для компонента
        document.addEventListener('click', (event) => {
            const {target} = event;

            // Открытие feedback
            if (!this.feedbackOpen) {
                if (target.matches(this.#attr.dataFeedbackInviteOpen)) {
                    this.openFeedback(this.#type.invite);
                } else if (target.matches(this.#attr.dataFeedbackServiceOpen)) {
                    this.openFeedback(this.#type.services);
                }
            }

            // Закрытие feedback если клик по темной области feedback
            if (target === this.feedbackElement || target.matches(this.#attr.dataFeedbackClose)) {
                this.closeFeedback();
            }

            // Отправка формы по клику
            if (target === this.processElement) {
                this.processForm().then();
            }
        });

    }

    static openFeedback(type = this.#type.invite) {

        // закрываем мобильное меню ели оно открыто
        if (MenuComponent.isMenuActive) {MenuComponent.closeBurgerMenu()}
        // Формируем заголовок
        let titleText = '';
        if (type === this.#type.services) {
            titleText = this.#title.services
        } else if (type === this.#type.invite) {
            titleText = this.#title.invite
        }

        if (this.feedbackTitleElement) {
            this.feedbackTitleElement.innerText = titleText;
        }

        this.feedbackElement.classList.add("open");
        this.feedbackOpen = true;
        document.documentElement.classList.add("is-lock");

        this.userData.type = type;
    }

    static closeFeedback() {
        this.feedbackElement.classList.remove("open");
        this.feedbackOpen = false;
        if (!MenuComponent.isMenuActive) {
            document.documentElement.classList.remove("is-lock");
        }
    }

    static validateFields(field, inputElement) {

        if (field.name.includes("phone")) {
            inputElement.value = formatPhoneInput(inputElement.value);
        }

        if (!inputElement.value.match(field.regex)) {
            inputElement.parentElement.classList.add("error");
            inputElement.parentElement.classList.remove("access");
            field.valid = false;
        } else {
            inputElement.parentElement.classList.remove("error");
            inputElement.parentElement.classList.add("access");
            field.valid = true;
            this.userData[field.name] = inputElement.value;
        }
        if (!inputElement.value) {
            inputElement.parentElement.classList.remove("error");
            inputElement.parentElement.classList.remove("access");
            this.userData[field.name] = '';
        }

        // делаем телефон не обязательным если поле телефона пустое,
        // но если не пустое то проходит валидация согласно регулярке
        if (!field.required && !inputElement.value) {
            field.valid = true;
        }

        this.validateForm();
    }

    static validateForm() {
        const isValid = this.fields.every(item => item.valid);
        if (this.processElement) {
            this.processElement.disabled = !isValid;
        } else {
            console.error("Кнопка для отправки формы не найдена, укажите ей id='feedback-process-btn'");
        }
        return isValid;
    }

    static async processForm() {
        if (!this.validateForm()) return;

        const requestParams = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: buildFormData(this.userData)
        }

        try {
            this.processElement.innerText = "Отправка данных";
            const response = await fetch('/api/send_email.php', requestParams);
            if (!response.ok) throw new Error('Ошибка отправки');
            const data = await response.json();

            let error = false;
            if(data.error) {
                error = true;
                if (data.errorMessage) { console.error(data.errorMessage) }
            }

            this.showThanks(error);
            this.resetForm();
        } catch (error) {
            this.showThanks(true);
            console.error(error);
            alert('Заявка не отправлена, попробуйте позже или свяжитесь с нами.');
        }

    }

    static resetForm() {
        this.userData = {};
        this.fields.forEach(field => {
            field.element.value = "";
            if (field.required) {
                field.valid = false;
            } else {
                field.valid = true;
            }
        });
        this.validateForm();
    }

    static showThanks(error = false) {
        if (error) {
            this.processElement.innerText = "Ошибка отправки";
            this.processElement.style.color = "red";
        } else {
            this.processElement.innerText = "Заявка отправлена";
            this.processElement.style.color = "green";
        }
        setTimeout(()=>{
            this.closeFeedback();
            this.processElement.innerText = "Оставить заявку";
            this.processElement.style.color = "";
        }, 3000)
    }
}